import { render, staticRenderFns } from "./check-for-breaches.vue?vue&type=template&id=b0858426&"
import script from "./check-for-breaches.vue?vue&type=script&lang=js&"
export * from "./check-for-breaches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports